export const GRETA_NEW_CHAT_DRAFT_KEY = '__new__'

// LRU backstop against unbounded localStorage growth, not a product limit.
export const GRETA_MAX_DRAFTS = 20

export const GRETA_DRAFT_TTL_MS = 30 * 24 * 60 * 60 * 1000
